import React from "react";
import { Chip } from "@mui/material";
import { STATUS } from "../constants/status";

const StatusChip = ({ status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case STATUS.active:
        return "success";
      case STATUS.fail:
        return "error";
      case STATUS.giveUp:
        return "primary";
      case STATUS.drop:
        return "default";
      default:
        return "default";
    }
  };

  return <Chip label={status} color={getStatusColor(status)} />;
};

export default StatusChip;
